import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthGuard } from '@/components/AuthGuard';
import { DashboardLayout } from '@/components/DashboardLayout';
import { LoginPage } from '@/pages/Login';
import { HomePage } from '@/pages/Home';
import { UsersPage } from '@/pages/Users';
import { UsersValidationPage } from '@/pages/UsersValidation';
import { UserDetailPage } from '@/pages/UserDetail';
import { AgentDetailPage } from '@/pages/AgentDetail';
import { SocietiesValidationPage } from '@/pages/SocietiesValidation';
import { SocietyDetailPage } from '@/pages/SocietyDetail';
import { MunicipalitiesPage } from '@/pages/Municipalities';
import { MunicipalityDetailPage } from '@/pages/MunicipalityDetail';
import { SearchPage } from '@/pages/Search';
import { SectorsPage } from '@/pages/Sectors';
import { SettingsPage } from '@/pages/Settings';
import { ModerationPage } from '@/pages/Moderation';
import { FeedPage } from '@/pages/Feed';
import { BrandsPage } from '@/pages/Brands';
import { SecurityDomainsPage } from '@/pages/SecurityDomains';
import { InterventionsPage } from '@/pages/Interventions';
import { InterventionDetailPage } from '@/pages/InterventionDetail';
import { SecurityRequestsPage } from '@/pages/SecurityRequests';
import { SecurityRequestDetailPage } from '@/pages/SecurityRequestDetail';
import { SecurityCatalogPage } from '@/pages/SecurityCatalog';
import { FeatureFlagsPage } from '@/pages/FeatureFlags';
import { DeepLinksDocsPage } from '@/pages/docs/DeepLinks';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <AuthGuard>
            <DashboardLayout />
          </AuthGuard>
        }
      >
        <Route path="/" element={<HomePage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/users/validation" element={<UsersValidationPage />} />
        <Route path="/users/:id" element={<UserDetailPage />} />
        <Route path="/agents/:id" element={<AgentDetailPage />} />
        <Route path="/societies/validation" element={<SocietiesValidationPage />} />
        <Route path="/societies/:id" element={<SocietyDetailPage />} />
        <Route path="/municipalities" element={<MunicipalitiesPage />} />
        <Route path="/municipalities/:id" element={<MunicipalityDetailPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/sectors" element={<SectorsPage />} />
        <Route path="/interventions" element={<InterventionsPage />} />
        <Route path="/interventions/:id" element={<InterventionDetailPage />} />
        <Route path="/moderation" element={<ModerationPage />} />
        <Route path="/feed" element={<FeedPage />} />
        <Route path="/brands" element={<BrandsPage />} />
        <Route path="/security-domains" element={<SecurityDomainsPage />} />
        <Route path="/security-requests" element={<SecurityRequestsPage />} />
        <Route path="/security-requests/:id" element={<SecurityRequestDetailPage />} />
        <Route path="/security-catalog" element={<SecurityCatalogPage />} />
        <Route path="/feature-flags" element={<FeatureFlagsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/docs/deep-links" element={<DeepLinksDocsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
